// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"452":"d73c3c1d","453":"32e7e080"}[chunkId] + ".chunk.js";
};